import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import PodcastEpisode from '../Podcast/PodcastEpisode';
import { addToManualQueueInfo, deleteFromManualQueueInfo, fetchLatestSubscribedEpisodes } from '../../actions';
import { isEpisodeExplicitlyMarkedPlayed, sortPubDate } from '../../lib/utils';
import { message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

class AddToQueue extends Component {

  componentDidMount() {
    // const { subscribedPodcasts } = this.props;
  }

  componentDidUpdate() {

  }

  onBtnClick = () => {
    const { episodesManualQueue, addToManualQueueInfo, deleteFromManualQueueInfo, podcastEpisode, userDetails } = this.props;
    if (!userDetails || !userDetails.uid) {
      message.warning('Please sign in to add to queue.');
      return;
    }
    const isInQueue = podcastEpisode.guid in episodesManualQueue;
    if (isInQueue) {
      deleteFromManualQueueInfo(podcastEpisode);
    } else {
      addToManualQueueInfo(podcastEpisode);
    }
  }

  render() {
    const { episodesManualQueue, podcastEpisode } = this.props;

    // const episodesManualQueue = vm.episodesManualQueue;
    const isInQueue = podcastEpisode.guid in episodesManualQueue;

    return (
      <div onClick={this.onBtnClick}>
        <p className='mb-0'>
          {isInQueue ? <MinusOutlined /> : <PlusOutlined />}
          {isInQueue ? ' Remove from Queue' : ' Add to Queue'}
        </p>
      </div>
    )
  }
}

AddToQueue.propTypes = {
  podcastEpisode: PropTypes.object.isRequired,
  episodesManualQueue: PropTypes.object,
  userDetails: PropTypes.object,
  addToManualQueueInfo: PropTypes.func,
  deleteFromManualQueueInfo: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    episodesManualQueue: state.episodesManualQueue,
    userDetails: state.userDetails,
    // episodesAutoQueue: state.episodesAutoQueue,
    // autoQueuePlaylistId: state.autoQueuePlaylistIdNotifier,
  }
}

// export default withRedux(initStore, null, null)(Personal)
const mapDispatchToProps = (dispatch) => {
  return {
    addToManualQueueInfo: bindActionCreators(addToManualQueueInfo, dispatch),
    deleteFromManualQueueInfo: bindActionCreators(deleteFromManualQueueInfo, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToQueue);
